import React from "react";
import Fade from "react-reveal/Fade";
import ProjectCard from "./ProjectCard/ProjectCard";
// import "./Projects.css";

function Projects() {
  return (
    <div className="project">
      <Fade top>
        <h1 style={{ color: "#ff4267", display:'flex', justifyContent:'center' }}>My Projects</h1>
      </Fade>

      <div className="card-body mt-5">
        <div className="row">
          <div className="col">
            <Fade left>
              <ProjectCard
                className="card"
                title="CryptoWorld"
                desc="A web app that allows users to gain information regarding cryptocurrenices to make an informed decision when investing"
                langs={["ReactJs", "Redux"]}
                liveLink="https://crypto-world-js.netlify.app/"
                githubLink="https://github.com/McAsh09/error404_fullstack_hack21"
              />
            </Fade>
          </div>
          <div className="col">
            <Fade right>
              <ProjectCard
                title="MobiVax"
                desc="A web app that targets vaccination of elderly and specially abled along with chatbot functionality "
                langs={["ReactJs", "Redux"]}
                liveLink="https://mobivax.netlify.app/"
                githubLink="https://github.com/McAsh09/error404_fullstack_hack21"
              />
            </Fade>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Fade left>
              <ProjectCard
                title="Projects Tracker"
                desc="A web app that allow users to add their hobby projects, users can edit their projects and can also delete them if they wish"
                langs={["ReactJs", "Redux"]}
                liveLink="https://my-hobby-projects.netlify.app/"
                githubLink="https://github.com/McAsh09/hobby-projects"
              />
            </Fade>
          </div>
          <div className="col">
            <Fade right>
              <ProjectCard
                title="Simon Game"
                desc="Implemented an electronic game of memory skill using VanillaJs and jQuery. An intuitive game that is easy to learn but hard to master"
                langs={["VanillaJS", "jQuery"]}
                liveLink="https://mcash09.github.io/simon-game/"
                githubLink="https://github.com/McAsh09/simon-game"
              />
            </Fade>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Fade left>
              <ProjectCard
                title="Drum Kit"
                desc="Made for the purpose of adding drum rolls along with having fun while
            doing so"
                langs={["VanillaJS"]}
                liveLink="https://mcash09.github.io/drum-kit/"
                githubLink="https://github.com/McAsh09/drum-kit"
              />
            </Fade>
          </div>
          <div className="col">
            <Fade right>
              <ProjectCard
                title="To-Do List"
                desc="A web app that allows users to create their daily tasks and delete them
            when the task is done"
                langs={["Nodejs", "ejs", "mongoDB"]}
                liveLink="https://shrouded-mesa-70728.herokuapp.com/"
                githubLink="https://github.com/McAsh09/todo-list"
              />
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
